import { forwardRef } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { COUNTRIES } from "@/constants/countries";

interface CountryData {
	name: string;
	dialCode: string;
	countryCode: string;
}

interface PhoneInputFieldProps {
	value: string;
	onChange: (phone: string) => void;
	onBlur?: () => void;
	placeholder?: string;
	onCountryChange: (countryCode: number) => void;
	onError: (message: string) => void;
	disabled?: boolean;
}

const PhoneInputField = forwardRef<HTMLInputElement, PhoneInputFieldProps>(
	(
		{
			value,
			onChange,
			onBlur,
			placeholder = "",
			onCountryChange,
			onError,
			disabled,
		},
		ref,
	) => {
		return (
			<PhoneInput
				disabled={disabled}
				inputProps={{ ref }}
				country={"us"}
				value={value}
				data-testid="phone-input"
				onBlur={onBlur}
				enableSearch
				onChange={(phone, data: CountryData) => {
					const getCountryCode = Object.values(COUNTRIES).find((country) => {
						return country.secondary === data.dialCode;
					});

					if (!getCountryCode) {
						onError("Invalid country code selected.");
						return;
					}
					const countryCodeAsNumber = Number.parseInt(getCountryCode.id);

					onCountryChange?.(countryCodeAsNumber);
					onChange?.(phone);
				}}
				placeholder={placeholder}
				inputStyle={{
					borderRadius: "16px",
					padding: "28px 0px 28px 64px",
					paddingTop: "28px",
					paddingBottom: "28px",
					width: "100%",
					color: "var(--textDark)",
					border: "1px solid rgba(11, 81, 71, 0.2)",
					fontSize: "17px",
					fontWeight: "bold",
					fontFamily: "DM Sans",
				}}
				buttonStyle={{
					border: "none",
					backgroundColor: "transparent",
					height: "100%",
					width: "100px",
					padding: "0px 0px 0px 8px",
					zIndex: 10,
				}}
				searchPlaceholder="Search country"
				searchStyle={{
					borderRadius: "var(--radius-default)",
					width: "100%",
					marginLeft: 0,
				}}
				disableSearchIcon={true}
			/>
		);
	},
);

export default PhoneInputField;
